(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aqee-delivery-eta"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('aqee-delivery-eta')) return;

    const TZ = 'Europe/Paris';
    const DAY = 86400000;

    /* Date "civile" = minuit UTC du jour voulu : l'arithmétique de jours
       ne dépend ainsi ni du fuseau du visiteur ni des changements d'heure. */
    const civil = (y, m, d) => new Date(Date.UTC(y, m - 1, d));
    const addDays = (date, n) => new Date(date.getTime() + n * DAY);
    const key = (date) => date.toISOString().slice(0, 10);

    const parisParts = (instant) => {
      const parts = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
      }).formatToParts(instant).forEach((p) => { parts[p.type] = Number(p.value); });
      return parts;
    };

    /* Instant réel correspondant à une heure murale de Paris. */
    const parisInstant = (date, minutes) => {
      const wall = date.getTime() + minutes * 60000;
      let guess = wall;
      for (let i = 0; i < 2; i++) {
        const p = parisParts(new Date(guess));
        const shown = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
        guess += wall - shown;
      }
      return guess;
    };

    /* Dimanche de Pâques (algorithme de Meeus / Butcher). */
    const easter = (y) => {
      const a = y % 19, b = Math.floor(y / 100), c = y % 100;
      const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31);
      const day = ((h + l - 7 * m + 114) % 31) + 1;
      return civil(y, month, day);
    };

    const frenchHolidays = (y, withPentecost) => {
      const e = easter(y);
      const list = [
        civil(y, 1, 1), addDays(e, 1), civil(y, 5, 1), civil(y, 5, 8), addDays(e, 39),
        civil(y, 7, 14), civil(y, 8, 15), civil(y, 11, 1), civil(y, 11, 11), civil(y, 12, 25),
      ];
      if (withPentecost) list.push(addDays(e, 50));
      return list.map(key);
    };

    /* Fermetures : une date par ligne (2026-12-24) ou une période (2026-08-03 > 2026-08-21). */
    const parseClosures = (raw) => {
      const out = [];
      (raw || '').split(/\n|,/).forEach((line) => {
        const found = line.match(/\d{4}-\d{2}-\d{2}/g);
        if (!found) return;
        const [y1, m1, d1] = found[0].split('-').map(Number);
        let current = civil(y1, m1, d1);
        const [y2, m2, d2] = (found[1] || found[0]).split('-').map(Number);
        const end = civil(y2, m2, d2);
        for (let n = 0; current <= end && n < 366; n++) {
          out.push(key(current));
          current = addDays(current, 1);
        }
      });
      return out;
    };

    const fmt = (options) => new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', ...options });
    const fmtLong = fmt({ weekday: 'long', day: 'numeric', month: 'long' });
    const fmtShort = fmt({ weekday: 'short', day: 'numeric', month: 'short' });
    const fmtWeekday = fmt({ weekday: 'long' });

    const escapeHtml = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

    class AqeeDeliveryEta extends HTMLElement {
      connectedCallback() {
        const d = this.dataset;
        this.cfg = {
          cutoff: Number(d.cutoff),
          prep: Number(d.prep),
          transitMin: Math.max(0, Number(d.transitMin)),
          transitMax: Math.max(Number(d.transitMin), Number(d.transitMax)),
          shipSaturday: d.shipSaturday === 'true',
          deliverSaturday: d.deliverSaturday === 'true',
          pentecost: d.pentecost === 'true',
          closures: new Set(parseClosures(d.closures)),
        };
        try {
          this.texts = JSON.parse(this.querySelector('[data-texts]').textContent);
        } catch (e) {
          this.texts = {};
        }
        this.holidayCache = {};
        this.render();
        this.timer = setInterval(() => this.render(), 30000);
        this.onVisible = () => { if (!document.hidden) this.render(); };
        document.addEventListener('visibilitychange', this.onVisible);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.onVisible);
      }

      isHoliday(date) {
        const y = date.getUTCFullYear();
        if (!this.holidayCache[y]) this.holidayCache[y] = new Set(frenchHolidays(y, this.cfg.pentecost));
        return this.holidayCache[y].has(key(date));
      }

      isShipDay(date) {
        const wd = date.getUTCDay();
        if (wd === 0 || (wd === 6 && !this.cfg.shipSaturday)) return false;
        return !this.isHoliday(date) && !this.cfg.closures.has(key(date));
      }

      isDeliveryDay(date) {
        const wd = date.getUTCDay();
        if (wd === 0 || (wd === 6 && !this.cfg.deliverSaturday)) return false;
        return !this.isHoliday(date);
      }

      advance(date, count, test) {
        let current = date;
        let left = count;
        while (left > 0) {
          current = addDays(current, 1);
          if (test(current)) left--;
        }
        return current;
      }

      compute(nowMs) {
        const p = parisParts(new Date(nowMs));
        const today = civil(p.year, p.month, p.day);
        const nowMinutes = p.hour * 60 + p.minute;

        let orderDay = today;
        if (!this.isShipDay(today) || nowMinutes >= this.cfg.cutoff) {
          orderDay = this.advance(today, 1, (x) => this.isShipDay(x));
        }
        const shipDay = this.advance(orderDay, this.cfg.prep, (x) => this.isShipDay(x));
        const nextDelivery = (x) => this.isDeliveryDay(x);
        const deliveryMin = this.advance(shipDay, this.cfg.transitMin, nextDelivery);
        const deliveryMax = this.advance(shipDay, this.cfg.transitMax, nextDelivery);
        const deadline = parisInstant(orderDay, this.cfg.cutoff);

        return { today, orderDay, shipDay, deliveryMin, deliveryMax, deadline, left: deadline - nowMs };
      }

      relative(date, today) {
        const diff = Math.round((date - today) / DAY);
        if (diff === 0) return this.texts.today || "aujourd'hui";
        if (diff === 1) return this.texts.tomorrow || 'demain';
        return null;
      }

      render() {
        const now = Date.now();
        const r = this.compute(now);
        const t = this.texts;
        const set = (ref, html) => {
          const el = this.querySelector(`[data-ref="${ref}"]`);
          if (el) el.innerHTML = html;
        };
        const strong = (s) => `<strong>${escapeHtml(s)}</strong>`;

        const minLabel = fmtLong.format(r.deliveryMin);
        const range = r.deliveryMax > r.deliveryMin;
        const title = range ? t.titleRange || t.title : t.title;
        set('title', escapeHtml(title || 'Livrée le {date}')
          .replace('{date}', strong(minLabel))
          .replace('{date_max}', strong(fmtLong.format(r.deliveryMax))));

        let countdown;
        if (r.left <= 24 * 3600000) {
          const total = Math.max(1, Math.ceil(r.left / 60000));
          const h = Math.floor(total / 60);
          const m = total % 60;
          const value = h > 0 ? `${h} h ${String(m).padStart(2, '0')} min` : `${m} min`;
          countdown = escapeHtml(t.countdown || 'Commande dans les {countdown}').replace('{countdown}', strong(value));
        } else {
          const cutoffH = Math.floor(this.cfg.cutoff / 60);
          const cutoffM = this.cfg.cutoff % 60;
          const hour = `${cutoffH} h${cutoffM ? String(cutoffM).padStart(2, '0') : ''}`;
          const day = this.relative(r.orderDay, r.today) || fmtWeekday.format(r.orderDay);
          countdown = escapeHtml(t.deadline || 'Commande avant {deadline}').replace('{deadline}', strong(`${day} ${hour}`));
        }
        set('countdown-text', countdown);

        const short = (date) => {
          const rel = this.relative(date, r.today);
          return rel ? rel.charAt(0).toUpperCase() + rel.slice(1) : fmtShort.format(date);
        };
        set('date-order', escapeHtml(short(r.today)));
        set('date-ship', escapeHtml(short(r.shipDay)));
        set('date-delivery', escapeHtml(range ? `${fmtShort.format(r.deliveryMin)} – ${fmtShort.format(r.deliveryMax)}` : short(r.deliveryMin)));

        this.setAttribute('data-ready', '');
      }
    }

    customElements.define('aqee-delivery-eta', AqeeDeliveryEta);
  })();
  } catch(e) { console.error(e); }
})();

})();
